module.exports = __webpack_public_path__ + "29c3f5090fd55c5acc1b5943937e4157.svg";